import { useEffect, useMemo, useState } from 'react';
import { useOrganization, useUser } from '@clerk/clerk-react';
import { useMyEngagements } from './useEngagements';
import { readRecent, RECENT_EVENT } from '../utils/recentEngagements';

/** The person's recently opened engagements, resolved against the firm's LIVE list. */
export function useRecentEngagements() {
  const { user } = useUser();
  const { organization } = useOrganization();
  const userId = user?.id;
  const orgId = organization?.id;
  const [ids, setIds] = useState(() => readRecent(userId, orgId));
  const { data } = useMyEngagements();

  useEffect(() => {
    const refresh = () => setIds(readRecent(userId, orgId));
    refresh();
    window.addEventListener(RECENT_EVENT, refresh);
    window.addEventListener('storage', refresh);
    return () => {
      window.removeEventListener(RECENT_EVENT, refresh);
      window.removeEventListener('storage', refresh);
    };
  }, [userId, orgId]);

  return useMemo(() => {
    const byId = new Map((data?.engagements ?? []).map((e) => [String(e._id), e]));
    return ids.map((id) => byId.get(id)).filter(Boolean);
  }, [ids, data]);
}
